<template>
    <div class="container px-0">
		<h3>Changes Signed For:</h3>

		<div v-for="ssow_group_review in form_submission.ssow_group_reviews">
			<table class="table table-sm">
				<thead>
					<tr>
						<th>Signed Version</th>
						<th>Current Version</th>
					</tr>
				</thead>
				<tbody>
					<tr>
						<td>{{ssow_group_review.signed_version}}</td>
						<td>{{ssow_group_review.audit_ssow_group.version}}</td>
					</tr>
				</tbody>
			</table>

			<table class="table table-sm mt-3" v-for="change in ssow_group_review.audit_ssow_group.audit_groups">
				<thead class="thead-dark">
					<tr>
						<th>{{change.relatable.title != undefined ? change.relatable.title : change.relatable.material}}</th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="line in change.changeLines">
						<td>{{line}}</td>
					</tr>
				</tbody>
			</table>
		</div>
    </div>
</template>

<script>
	export default {
		name: "SsowSubmission",
		props: [
        	'form_submission',
            'name'
        ]
	}
</script>
